module.exports = __webpack_public_path__ + "static/media/my_assets_user_select.4725a6eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_user_select.png
// module id = 753
// module chunks = 0 1